import Fieldset from '@algbra/ui/components/Fieldset/Fieldset'
import GreyBox from '@algbra/ui/components/GreyBox/GreyBox'
import { mapIndexed } from 'rambdax'
import { ReactNode } from 'react'

export type ContactInfoDetail = {
  title: string
  description: ReactNode
}
export type ZoneContactBoxFieldsetProps = {
  __typename: 'StrapiGQL_ComponentZonesFieldset'
  title: ReactNode
  description?: ReactNode
  details?: ContactInfoDetail[]
}
export default function ZoneContactBoxFieldset(
  props: ZoneContactBoxFieldsetProps
) {
  const { title, details } = props
  return (
    <GreyBox title={title}>
      {mapIndexed(
        (fieldset, index) => (
          <Fieldset key={`fieldset-${index}`} label={fieldset.title}>
            {fieldset.description}
          </Fieldset>
        ),
        details || []
      )}
    </GreyBox>
  )
}
